<template>
  <div class="flex flex-col font-cera-pro">
    <label v-if="label" :class="`mb-1 text-base font-bold ${labelColorClasses}`" :for="inputId">
      {{ label }}
    </label>
    <div
      :class="`
        flex w-full
        px-4 py-2.5
        rounded
        border-solid border-2 ${borderColorClasses}
        placeholder-light-grey
        text-dark-grey text-base
        bg-white
        ${cursorClasses}
      `"
    >
      <slot name="prefix"></slot>
      <input
        type="text"
        class="w-full"
        v-model="value"
        @input="$event.target.composing = false"
        :id="inputId"
        :placeholder="placeholder"
        :name="name"
        :disabled="disabled"
      />
    </div>
    <div v-if="errorMessage" class="flex pt-2">
      <sprite id="app/error-filled" class="mt-1 mr-2 text-raspberry" />
      <div class="text-raspberry text-sm font-medium">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import Sprite from "@/shared/sprite"

export default {
  name: "InputText",
  components: {
    Sprite
  },
  props: {
    label: {
      type: String,
      default: "",
      required: false
    },
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: String,
      default: "",
      required: false
    },
    name: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: "",
      required: false
    },
    errorMessage: {
      type: String,
      default: "",
      required: false
    },
    forceActiveClass: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      localValue: ""
    }
  },
  computed: {
    borderColorClasses() {
      if (this.disabled) {
        return "border-light-grey"
      }

      if (this.errorMessage) {
        return "border-raspberry focus:border-raspberry-2 hover:border-raspberry-2"
      }

      if (this.forceActiveClass) {
        return "border-green"
      }

      return "border-light-grey focus:border-green hover:border-green"
    },
    cursorClasses() {
      return this.disabled ? "cursor-not-allowed" : "hover:cursor-text"
    },
    labelColorClasses() {
      return this.disabled ? "text-light-grey" : "text-mid-grey"
    }
  },
  watch: {
    localValue(value) {
      this.$emit("input", value)
    },
    value: {
      immediate: true,
      handler(value) {
        this.localValue = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/*
  we set the hight and width here since tailwind classes are overwritten by
  '.sprite-vue--category, .sprite-vue--app', that sets width and hight to 1.5rem
  */
.sprite-vue--error-filled {
  display: flex;
  flex-shrink: 0;
  width: 0.75rem;
  height: 0.75rem;
}
</style>
